<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
  <div class="card-block" style="margin: 10px;">
    <div class="head-block-title">
      <div class="row">
        <div class="col-md-8">
          <span class="listHeaderText">Client ({{customerListData?.length}})</span>
        </div>
        <div class="col-md-4 d-flex" style="justify-content: flex-end;">
          <export [showIconOnly]="false" [data]="selectedExportData"></export>
        </div>
      </div>
    </div>

    <div class="main-field">
      <div class="main-block-content">
        <div style="margin: 10px;">
          <app-common-table [columnDefs]="columnDefs" [data]="customerListData"
            (commonDropdownChange)="changeAddUpdateModalState($event,'','Edit')"
            (selectedRowsChange)="onSelectedRowsChange($event)">
          </app-common-table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Card Starts for mobile screen -->
<div class="content-area">
  <span class="listHeaderText">Client ({{customerListData?.length}})</span>
  <div class="row">
    <div class="col-md-6">
      <div class="dropdownMenu d-flex mt-1">
        <div class="export-actionbutton-icon">
          <img src="../../../../assets/images/exportwhite.svg">
        </div>
        <span class="add-actionbutton-text dropdown-toggle"> Export</span>

        <ul class="dropdownMenu-content" style="text-align:center;top: 37px;">
          <button type="button" class="btn" data-toggle="modal" data-target=".export-modal"><span
              class="dropdownMenu-content-option"><a (click)="toggleExport('excel')">Excel</a></span></button>
          <button type="button" class="btn d-flex" style="position: relative;padding-left: 35px;" data-toggle="modal"
            data-target=".export-modal"><span class="dropdownMenu-content-option"><a
                (click)="toggleExport('pdf')">PDF</a></span></button>
        </ul>
      </div>
    </div>
  </div>

  <!--Export Modal-->
  <!-- <div class="modal export-modal" [ngClass]="showExport ? 'booking-modal-show':'booking-modal-hide'" tabindex="-1"
    role="dialog" aria-labelledby="myLargeModalLabel">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <app-export-list (exportValues)="exportValues($event)" (hideModal)="hideExport()" style="height: 59vh;"
          [exportType]="exportSelectedType" [columns]="exportColumns" [dataList]="customerListData"
          [rowSelection]="'multiple'" [exportColumnKeys]="columnKeys" [submitButtonTitle]="'Export'"
          [headerName]="'Client List'"></app-export-list>
      </div>
    </div>
  </div> -->
  <div class="mb-2 mr-2">
    <div class="row">
      <div class="col-md-12">
        <span>
          <input type="search" class="form-control inputSearch" placeholder="Search customer" [(ngModel)]="filterTerm">
        </span>
      </div>
    </div>
  </div>
  <div class="row row-cards-one">
    <div class="col-md-12 col-lg-3 col-xl-3">
      <div class="mycard bg1" *ngFor="let customer of customerListData | filter: filterTerm">
        <div class="left">
          <tr>
            <td>
              <b><i class="fa fa-user" aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{customer?.nameInitial?.name + '.' + ' '}}{{customer?.firstName}} {{customer.lastName}}</b><br>
              <b><i class="fa fa-inr" aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{customer?.primaryPhoneNo}}</b>
            </td>
          </tr>
        </div>
        <div class="right d-flex align-self-center">
          <tr>
            <td>
              <div class="dropdownMenu">
                <div>
                  <img src="../../../../assets/images/Action icon red.svg" alt="">
                </div>
                <div class="dropdownMenu-content dropdownActionMenu" id="actionMenuContent{{customer.id}}"
                  style="top:24px;right:0vh;">

                  <span class="dropdownMenu-content-option"
                    (click)="changeAddUpdateModalMobileView(customer,'Edit')"><img [src]="editIcon" alt="Edit Icon"
                      class="icon-img" />Edit</span>
                </div>
              </div><br>
              <b><img src="../../../../assets/images/Cards Icon.svg" alt="" height="20" width="20">
                {{customer?.panCardNo}}</b><br>
              <br>
            </td>
          </tr>
        </div>
      </div>
    </div>
  </div>
</div>